module.exports = __webpack_public_path__ + "static/hoverimage-0e73e1bdb48cda54ed63ac66c8c71303.png";